import { useEffect } from 'react';
import { InvoiceUpdatedType, PusherEventName } from 'anchor-scout-common/types/pusher';
import { useStateInRef } from 'seagull';
import { useBusinessChannelEventBinder } from '~/pusher/useBusinessChannelEventBinder';
export function useInvoiceUpdatedEvent(callbacks) {
    const getCallbacks = useStateInRef(callbacks);
    const { startListening } = useBusinessChannelEventBinder(PusherEventName.InvoiceUpdated, 'scout');
    useEffect(()=>{
        startListening(async (payload)=>{
            try {
                const current = getCallbacks();
                await current.onInvoiceRefetch(payload.invoiceId);
                if (payload.type === InvoiceUpdatedType.Unvoided) {
                    var _current_onUnvoided;
                    (_current_onUnvoided = current.onUnvoided) === null || _current_onUnvoided === void 0 ? void 0 : _current_onUnvoided.call(current, payload.invoiceId);
                } else if (payload.type === InvoiceUpdatedType.UnmarkedAsPaidExternally) {
                    var _current_onUnmarkedAsPaidExternally;
                    (_current_onUnmarkedAsPaidExternally = current.onUnmarkedAsPaidExternally) === null || _current_onUnmarkedAsPaidExternally === void 0 ? void 0 : _current_onUnmarkedAsPaidExternally.call(current, payload.invoiceId);
                }
            } catch (unused) {
            // Refetch failed — component shows stale data until next page refresh
            }
        });
    }, []);
}
